const getAllCallerIDs = function (state) {
  const { callerIDs } = state
  return callerIDs
}

export default getAllCallerIDs
